/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SendPhoneOtpDto } from '../models/SendPhoneOtpDto';
import type { UpdatePhoneVerificationDto } from '../models/UpdatePhoneVerificationDto';
import type { VerificationResponse } from '../models/VerificationResponse';
import type { VerifyOtpDto } from '../models/VerifyOtpDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccountVerificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Send email verification code
     * Generates a 6-digit OTP code, stores it server-side with a 10-minute TTL, and sends it to the user's registered email address. Rate limited to 3 requests per 10 minutes.
     * @returns VerificationResponse Verification code sent.
     * @throws ApiError
     */
    public accountVerificationControllerSendEmailVerification(): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/email/send',
            errors: {
                400: `Email already verified or rate limit exceeded.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Verify email code
     * Validates the OTP code submitted by the user. On success, marks the user's email as VALIDATED. Max 5 failed attempts before code is invalidated.
     * @returns VerificationResponse Email verified successfully.
     * @throws ApiError
     */
    public accountVerificationControllerVerifyEmailCode({
        requestBody,
    }: {
        requestBody: VerifyOtpDto,
    }): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/email/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired verification code.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Resend email verification code
     * Invalidates the previous code and sends a new one. Alias for the send endpoint.
     * @returns VerificationResponse Verification code sent.
     * @throws ApiError
     */
    public accountVerificationControllerResendEmailVerification(): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/email/resend',
            errors: {
                400: `Email already verified or rate limit exceeded.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Send phone verification code
     * Generates a 6-digit OTP code and sends it via SMS. If a phone number is provided in the request body, it is saved to the user's profile first. Rate limited to 3 requests per 10 minutes.
     * @returns VerificationResponse Verification code sent.
     * @throws ApiError
     */
    public accountVerificationControllerSendPhoneVerification({
        requestBody,
    }: {
        requestBody: SendPhoneOtpDto,
    }): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/phone/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Phone already verified, no phone number provided or on profile, or rate limit exceeded.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Verify phone with OTP code
     * Validates the OTP code sent via SMS. On success, marks the user's phone as VALIDATED and emits a phone_verified event. Max 5 failed attempts before code is invalidated.
     * @returns VerificationResponse Phone verified successfully.
     * @throws ApiError
     */
    public accountVerificationControllerVerifyPhone({
        requestBody,
    }: {
        requestBody: VerifyOtpDto,
    }): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/phone/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired verification code.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Resend phone verification code
     * Invalidates the previous code and sends a new one via SMS. If a phone number is provided, it is saved to the profile first. Alias for the send endpoint.
     * @returns VerificationResponse Verification code sent.
     * @throws ApiError
     */
    public accountVerificationControllerResendPhoneVerification({
        requestBody,
    }: {
        requestBody: SendPhoneOtpDto,
    }): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/verification/phone/resend',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Phone already verified, no phone number provided or on profile, or rate limit exceeded.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Update phone number
     * Updates the user's phone number and resets its verification status to PENDING. Does not auto-send verification code.
     * @returns VerificationResponse Phone number updated.
     * @throws ApiError
     */
    public accountVerificationControllerUpdatePhone({
        requestBody,
    }: {
        requestBody: UpdatePhoneVerificationDto,
    }): CancelablePromise<VerificationResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/users/verification/phone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
}
